import { useState } from "react";
import { Dropdown, DropdownSkeleton } from "carbon-components-react";
import { Label } from "../Label";

import useSWR from "swr";
import { URL, Fetcher as F } from "../../../api";

export const Contract = ({
  id,
  className,
  style,
  filter = {},
  field = {},
  data,
  onChange,
}) => {
  const { puerpera } = filter;
  const { key, required = false } = field;
  const title = "合約來源";

  const [shouldValidate, setShouldValidate] = useState(false);
  const invalid = shouldValidate && required && data === undefined;

  const url = `${URL.contract}?puerpera=${puerpera}`;
  const { data: list = [] } = useSWR([url], F.withToken, {
    revalidateOnFocus: false,
  });

  const displayNames = list.map((x) => {
    return {
      id: x.id,
      displayName: x.contract_number,
    };
  });

  const listWithNone = [{ id: 0, displayName: "無" }, ...displayNames.slice(0)];
  const item = (listWithNone || []).find(
    (x) => x.id === (data === null ? 0 : data)
  );

  return !list ? (
    <DropdownSkeleton id={id} className={className} style={style} />
  ) : (
    <Dropdown
      id={id}
      className={className}
      style={style}
      titleText={<Label required={required}>{title}</Label>}
      label="請選擇"
      items={listWithNone}
      itemToString={(x) => x.displayName}
      selectedItem={item}
      invalid={invalid}
      invalidText="此為必填欄位"
      onFocus={() => setShouldValidate(false)}
      onBlur={() => setShouldValidate(true)}
      onChange={(e) => {
        const v = e.selectedItem;
        if (typeof onChange !== "function") return;
        onChange({ [key]: v.id });
      }}
    />
  );
};
